import { useState } from 'react';
import {
    Button, Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import cls from 'classnames';
import { useMountEffect } from '@s20/hooks/state.hooks';
import { FormValidated } from '../FormElements';
import { SaveButton } from '../SaveButton';
import './index.scss';

const defaultOnSubmit = () => { };
const defaultProps = {};

export const ModalForm = ({
    toggle,
    onSubmit = defaultOnSubmit,
    isOpen = false,
    title = null,
    children,
    SaveButtonProps = defaultProps,
    CancelButtonProps = defaultProps,
    className = '',
    initialValues = {},
    ...restProps
}) => {
    const [isValidated, setIsValidated] = useState(false);

    useMountEffect(() => {
        setIsValidated(false);
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    return (
        <Modal
            toggle={toggle}
            isOpen={isOpen}
            container="body"
            trapFocus
            external
            backdropClassName="modal-form-backdrop"
            className={cls('modal-form modal-mobile-fullscreen', className)}
            {...restProps}
        >

            {Boolean(title) && (
                <ModalHeader toggle={toggle}>
                    {title}
                </ModalHeader>
            )}

            {typeof children === 'function' ? (
                <FormValidated
                    id="modal-form"
                    name="modal-form"
                    onSubmit={onSubmit}
                    setIsValidated={setIsValidated}
                    isValidated={isValidated}
                    initialValues={initialValues}
                >
                    {({
                        submitHandler, values, onChange, saving,
                        setFieldValue,
                    }) => (
                        <>
                            <ModalBody>
                                {children({ values, onChange, setFieldValue })}
                            </ModalBody>

                            <ModalFooter>
                                <SaveButton
                                    saving={saving}
                                    {...SaveButtonProps}
                                    onClick={submitHandler}
                                />

                                <Button
                                    color="link"
                                    type="button"
                                    onClick={toggle}
                                    {...CancelButtonProps}
                                    className={cls('cancel-button', 'text-muted')}
                                >
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </FormValidated>
            ) : (
                <FormValidated
                    id="modal-form"
                    name="modal-form"
                    onSubmit={onSubmit}
                    setIsValidated={setIsValidated}
                    isValidated={isValidated}
                >
                    <ModalBody>
                        {children}
                    </ModalBody>

                    <ModalFooter>
                        <SaveButton
                            {...SaveButtonProps}
                        />

                        <Button
                            color="link"
                            type="button"
                            onClick={toggle}
                            {...CancelButtonProps}
                            className={cls('cancel-button', 'text-muted')}
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </FormValidated>
            )}
        </Modal>
    );
};

export * from './Alert';